import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, Inject, signal, WritableSignal } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { ImageCroppedEvent, ImageTransform } from "ngx-image-cropper";
import { ImageCropperComponent } from "ngx-image-cropper";
import { MatSliderModule } from "@angular/material/slider";
import { FormControl, ReactiveFormsModule } from "@angular/forms";

@Component({
  selector: "app-image-cropper-dialog",
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ImageCropperComponent,
    MatSliderModule,
    ReactiveFormsModule,
  ],
  templateUrl: "./image-cropper-dialog.component.html",
  styleUrl: "./image-cropper-dialog.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class ImageCropperDialogComponent {
  imageChangedEvent: any;
  croppedImage: any = "";
  scale = 1;
  transform: ImageTransform = {
    translateUnit: "px",
    scale: 1,
    rotate: 0,
    flipH: false,
    flipV: false,
    translateH: 0,
    translateV: 0,
  };
  scaleControl = new FormControl(1);
  imageName: WritableSignal<string> = signal<string>("");
  dialogueHeading: WritableSignal<string> = signal<string>("");
  subHeading: WritableSignal<string> = signal<string>("");

  constructor(public dialogRef: MatDialogRef<ImageCropperDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.imageChangedEvent = this.data.event;
    this.dialogueHeading.set(this.data.heading);
    this.subHeading.set(this.data.subHeading);
    this.imageName.set(this.data.event.target.files[0].name);
    this.scaleControl.valueChanges.subscribe((scale) => {
      this.updateTransform(scale || 1);
    });
  }

  onImageCropped(event: ImageCroppedEvent) {
    if (event.base64) {
      this.croppedImage = event.base64;
    } else if (event.blob) {
      this.blobToBase64(event.blob).then((base64) => {
        this.croppedImage = base64;
      });
    }
  }

  blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  }

  updateTransform(scale: number) {
    this.transform = {
      ...this.transform,
      scale: scale,
    };
  }

  onSave() {
    this.dialogRef.close({ croppedImage: this.croppedImage, scale: this.scale, imageName: this.imageName() });
  }

  onCancel() {
    this.dialogRef.close(null);
  }

  onFileChanged(event: any) {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/gif'];
      
      if (validTypes.includes(file.type)) {
        this.imageChangedEvent = event;
        this.imageName.set(file.name);
      } else {
        alert('Please select a valid image file (JPG, JPEG, PNG, WEBP, or GIF)');
        event.target.value = ''; // Clear the file input
      }
    }
  }
}

